export function setScrollbarVar() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
}

export function initScrollbarWidth() {
  setScrollbarVar();

  window.addEventListener("resize", setScrollbarVar);
}
